export { default as GlobalSalaryComponents } from './globalSalaryComponents.component';
